<template>
  <div>
    <b-modal id="bv-modal-new-card" hide-footer>
      <template #modal-title>{{title}} card</template>

      <div class="row">
        <div class="col">
            <div v-if="payment_response" class="alert alert-danger text-center">{{payment_response}}</div>
            <div class="text-center">
      
    <div v-if="publishableKey">

    <stripe-element-card
      ref="elementRef"
      :classes="{ base: 'form-control', focus: 'form-control', invalid: 'stripe_invalid', complete: 'form-control', empty: 'stripe_empty' }"
      :pk="publishableKey"
      :hidePostalCode="true"
      @token="tokenCreated"/>

    <a v-if="loading" href="#/" class="btn btn-danger my-2 col"><i class="fas fa-spinner fa-spin"></i></a>
    <a v-else href="#/" @click="submit" class="btn btn-danger my-2 col">Save Card</a>
    </div>
            </div>
        </div>
      </div>

    </b-modal>
  </div>
</template> 

<script>
import { StripeElementCard } from '@vue-stripe/vue-stripe';

export default {

  props: ['title', 'card'],

  components: {
    StripeElementCard,
  },

  data() {
    return {
      updating: false,
      token: null,
      publishableKey: null,
      payment_response: null,
      payment_success: false,
      loading: false,
    };
  },

  created() {
    this.getStripeKey();
  },

  methods: {

    getStripeKey() {
      axios.get('/subscriptions/stripe-key').
      then((response) => {
        this.publishableKey = response.data;
      });
    },

    submit () {
      this.$refs.elementRef.submit();
    },

    tokenCreated (token) {
      this.token = token;
      this.makePayment();
    },

    makePayment() {
      
      this.payment_response = null;
      this.loading = true;

      axios.post('/billing/new-card', {
        stripeToken: this.token.id,
        card: this.card
      })
      .then((response) => {

        if (response.data.success) {
          this.$emit('card-updated');
          this.hideModalNewCard();
        } else {
          this.payment_response = response.data.message;
        }
        this.loading = false;

      });
    },

    hideModalNewCard() {
      this.$bvModal.hide('bv-modal-new-card');
    },

    
  },
};
</script>

<style scoped>
/* textarea.form-control { font-size: 0.9rem !important; }

input.form-control, input.form-control:focus {
  border-radius: 5px !important;
  border: none !important;
} */
.btn { border-radius: 5px !important; }
.logos {
  background-color: #fff;
  padding: 0.4rem 2rem;
  border-radius: 5px;
  width:fit-content;
  margin: 0 auto 1rem auto;
}
.form-control {
  border-radius:50px !important;
}
.form-control:focus {
  box-shadow: none !important;
  outline: none !important;
}
.StripeElement--focus {
  box-shadow: none !important;
  outline: none !important;
}
</style>